export default "__VITE_ASSET__DjrdvUW3__"